import { render } from "./PackagesManagerOrdersCentralStage.vue?vue&type=template&id=ecc845ea&scoped=true"
import script from "./PackagesManagerOrdersCentralStage.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersCentralStage.vue?vue&type=script&lang=js"

import "./PackagesManagerOrdersCentralStage.vue?vue&type=style&index=0&id=ecc845ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc845ea"]])

export default __exports__